import { http } from '@/http'

export default {
  getDashboard(companyId) {
    const params = companyId ? { companyId } : {}
    return http.get('/dashboard', { params })
  },
}
